import requset from "utils/request";
import baseURL from '@/api/env.js'
/* 登录 */
export function login(params, type) {
    return requset({
        url: baseURL.AHEAD + "/user/auth/code/login",
        method: "POST",
        params
    });
}
/* 登出 */
export function logout() {
    return requset({
        url: baseURL.AHEAD + "/user/auth/logout",
        method: "POST"
    });
}
/* 验证码 */
export function usercaptcha(params) {
    return requset({
        url: baseURL.AHEAD + '/user/auth/mobile/captcha',
        method: "get",
        params
    });
}
/* 刷新Token */
export function authrefreshToken(params) {
    return requset({
        url: `${baseURL.AHEAD}/user/auth/refreshToken`,
        method: "POST",
        params
    });
}
/* 用户设置 */
// 获取用户信息
export function getInfo() {
    return requset({
        url: baseURL.AHEAD + "/user/account/info",
        // url: `${baseURL.AHEAD}/user/account/info`,
        method: "get"
    });
}

/* 账号列表 */
export function accountListApi(params) {
    return requset({
        url: baseURL.AHEAD + '/writer/writer/account/list',
        method: "get",
        params
    });
}
/* 添加子账号 */
export function addAccountApi(params) {
    return requset({
        url: baseURL.AHEAD + "/writer/writer/account/add",
        method: "POST",
        params
    });
}
/* 切换子账号 */
export function changeAccountApi(params) {
    return requset({
        url: baseURL.AHEAD + "/user/auth/account/change",
        method: "POST",
        params
    });
}




